import React, { useContext } from "react";
import { addEuro, getImgUrl } from "../../utils/generalUtils";
import { AcUnit, DriveEta, LocalGasStation, People } from "@mui/icons-material";
import LuggageIcon from "@mui/icons-material/Luggage";
import { CarDoor } from "../../assets/svgs";
import { Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ClientContext } from "../../../store/context";

function VehicleCards({ cars, settings }) {
  const navigate = useNavigate();
  const {
    setCarToReserve,
    pickUpDate,
    dropOffDate,
    pickUpTime,
    dropOffTime,
    pickUpLocation,
    dropOffLocation,
  } = useContext(ClientContext);
  return (
    <div className="vehicle-container">
      {cars?.map((car) => (
        <Paper
          key={car.id}
          className="vehicle"
          elevation={7}
          sx={{ flexDirection: { xs: "column", lg: "row" } }}
        >
          <div className="vehicle-column">
            <img src={getImgUrl(car.imgUrl)} />
          </div>

          <div className="vehicle-column">
            <span
              style={{
                flex: 1,
                textAlign: "center",
                fontWeight: "600",
                fontSize: "22px",
              }}
            >
              {car.title}
            </span>
            <div style={{ flex: 2 }} className="vehicle-trait-grid">
              <div className="vehicle-trait">
                <LocalGasStation />
                <span>{car.traitMap.FUEL}</span>
              </div>
              <div className="vehicle-trait">
                <LuggageIcon />
                <span>{car.traitMap.LUGGAGE}</span>
              </div>
              <div className="vehicle-trait">
                <DriveEta />
                <span>{car.traitMap.TRANSMISSION}</span>
              </div>
              <div className="vehicle-trait">
                <AcUnit />
                <span>{car.traitMap.AC}</span>
              </div>
              <div className="vehicle-trait">
                <People />
                <span>{car.traitMap.PASSENGERS}</span>
              </div>
              <div className="vehicle-trait">
                <CarDoor />
                <span>{car.traitMap.DOORS}</span>
              </div>
            </div>
          </div>

          <div
            className="vehicle-column"
            style={car.currentRate === 0 ? { justifyContent: "center" } : {}}
          >
            {car.currentRate !== 0 ? (
              car.currentRate < car.rate ? (
                <div style={{ flex: 1, display: "flex" }}>
                  <span className="vehicle-before-discound-text">
                    {addEuro(car.rate)}
                  </span>{" "}
                </div>
              ) : (
                <div style={{ flex: 1 }} />
              )
            ) : (
              <></>
            )}
            {car.currentRate !== 0 ? (
              <div className="vehicle-pricing-container">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span className="vehicle-rate-perDay-text">
                    {addEuro(car.currentRate)}
                  </span>
                  <span className="vehicle-perDay-text">/per Day</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            <div
              onClick={() => {
                if (
                  pickUpDate &&
                  pickUpLocation &&
                  pickUpTime &&
                  dropOffDate &&
                  dropOffLocation &&
                  dropOffTime &&
                  car.currentRate !== 0
                ) {
                  navigate("/reservation");
                  setCarToReserve(car);
                } else {
                  navigate("/about", {
                    state: {
                      pickUpDate: pickUpDate
                        ? `${pickUpDate.format("YYYY-MM-DD")}T${
                            pickUpTime ?? "00:00"
                          }:00`
                        : null,
                      dropOffDate: dropOffDate
                        ? `${dropOffDate.format("YYYY-MM-DD")}T${
                            dropOffTime ?? "00:00"
                          }:00`
                        : null,
                      title: car?.title,
                      pickUpLocation: pickUpLocation ?? null,
                      dropOffLocation: pickUpLocation ?? null,
                    },
                  });
                }
              }}
              style={
                car.currentRate !== 0
                  ? { flex: 1.6, padding: "5px", maxHeight: "44px" }
                  : { height: "40%", maxHeight: "44px" }
              }
              className="vehicle-reservation"
            >
              <span>
                {car.currentRate !== 0
                  ? settings?.RESERVE
                  : settings?.CONTACT_US}
              </span>
            </div>
          </div>
        </Paper>
      ))}
    </div>
  );
}

export default VehicleCards;
